import { MapGeometry } from '@core/domain/model/consumption/map-geometry.model';
import { MapCoords } from '@core/domain/model/consumption/map-coords.model';
import { MapFilter } from '@core/domain/model/consumption/map-filter.model';
import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import { SortEvent } from '@shared/components/table/sort/model/sort.model';
import { ConsumptionRequestListFilter } from '@pages/my-consumption/consumption/ui/consumption-request-list/model/consumption-request-list.filter';
import { ConsumptionRequest } from '@core/domain/model/consumption/consumption-request.model';
import {
  AccumulatedConsumption,
  AccumulatedConsumptionGraphType,
  ComparativeConsumptionByInstallation,
  ComparativeConsumptionGraphType,
  ConsumptionFilter,
  ConsumptionTabCode,
} from '@core/domain/model/consumption/consumption.model';

export interface ConsumptionState {
  tabs: Array<ConsumptionTabCode>;
  currentTab: ConsumptionTabCode;
  map: {
    errorGeometry: string | null;
    errorCoords: string | null;
    geometry: MapGeometry | null;
    coords: MapCoords[] | null;
    filter: MapFilter;
  };
  requestList: {
    data: ConsumptionRequest[];
    filter: ConsumptionRequestListFilter;
    page: PaginatorInput;
    sort: SortEvent;
    error: string | null;
  };
  graphs: {
    accumulated: {
      filter: ConsumptionFilter | null;
      graphType: AccumulatedConsumptionGraphType;
      previousData: AccumulatedConsumption[] | null;
      currentData: AccumulatedConsumption[] | null;
      error: boolean;
    };
    comparative: {
      filter: ConsumptionFilter | null;
      graphType: ComparativeConsumptionGraphType;
      data: ComparativeConsumptionByInstallation[] | null;
      error: string | null;
    };
  };
}

export const consumptionInitialState: ConsumptionState = {
  tabs: ['accumulated', 'comparative', 'map'],
  currentTab: 'accumulated',
  map: {
    errorGeometry: null,
    errorCoords: null,
    geometry: null,
    coords: null,
    filter: {},
  },
  requestList: {
    data: [],
    filter: {},
    page: {
      pageIndex: 1,
      pageSize: 5,
    },
    sort: {
      sortName: 'requestDate',
      sortDir: 'desc',
    },
    error: null,
  },
  graphs: {
    accumulated: {
      filter: null,
      graphType: 'line',
      previousData: null,
      currentData: null,
      error: false,
    },
    comparative: {
      filter: null,
      graphType: 'line',
      data: null,
      error: null,
    },
  },
};
